import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  no: {
    // Navigation
    nav: {
      services: 'Tjenester',
      helpers: 'Hjelpere',
      groups: 'Grupper',
      jobs: 'Foresp\u00f8rsler',
      dashboard: 'Kontrollpanel',
      myBookings: 'Mine m\u00f8ter',
      login: 'Logg inn',
      logout: 'Logg ut',
      getStarted: 'Kom i gang',
      findHelpers: 'Finn Hjelpere',
      helper: 'Hjelper',
      careSeeker: 'Omsorgssøker',
    },
    pageTitle: {
      home: 'Vennli | Trygge møter mellom generasjoner',
      login: 'Vennli – Logg inn',
      register: 'Vennli – Registrer deg',
      verifyEmail: 'Vennli – Bekreft e-post',
      forgotPassword: 'Vennli – Glemt passord',
      resetPassword: 'Vennli – Tilbakestill passord',
      helpers: 'Vennli – Hjelpere',
      helperProfile: 'Vennli – Hjelperprofil',
      groups: 'Vennli – Grupper',
      groupDetail: 'Vennli – Gruppe',
      jobs: 'Vennli – Forespørsler',
      jobDetail: 'Vennli – Forespørsel',
      createJob: 'Vennli – Ny forespørsel',
      services: 'Vennli – Tjenester',
      serviceDetail: 'Vennli – Tjeneste',
      createService: 'Vennli – Nytt tilbud',
      dashboard: 'Vennli – Kontrollpanel',
      bookings: 'Vennli – Mine møter',
      bookingDetail: 'Vennli – Møtedetaljer',
      notifications: 'Vennli – Varsler',
      notificationSettings: 'Vennli – Varslingsinnstillinger',
      availability: 'Vennli – Tilgjengelighet',
      admin: 'Vennli – Admin',
      careSeekerProfile: 'Vennli – Profil',
      economy: 'Vennli – Økonomi',
      stripeReturn: 'Vennli – Stripe-oppsett',
      contact: 'Vennli – Kontakt oss',
    },
    // Landing page
    landing: {
      headline1: 'Koble',
      headline2: 'generasjoner',
      subtitle: 'Finn noen som kan hjelpe, avtal pris og m\u00f8tes p\u00e5 en trygg og hyggelig m\u00e5te.',
      dnaLine: 'Vennli er en m\u00f8teplass, ikke en markedsplass.',
      heroPaymentNote: 'Pris avtales p\u00e5 forh\u00e5nd. Betaling skjer trygt i Vennli.',
      findHelper: 'Finn en hjelper',
      becomeHelper: 'Bli en hjelper',
      howItWorks: 'Hvordan funker det?',
      earlyAccess: 'Vi er i tidlig fase. Bli med og bygg Vennli med oss \uD83D\uDC9B',
      safetyFirst: 'Trygghet f\u00f8rst',
      safetyFirstDesc: 'Vi bygger for tillit og verdighet',
      generationsTitle: 'Hvem er vi for',
      generationsHeadline: 'Tre generasjoner, ett fellesskap',
      generationsSubtitle: 'Vennli kobler sammen mennesker som vil bidra, familier som trenger avlastning, og eldre som \u00f8nsker selskap og hjelp.',
      youngTitle: 'Unge',
      youngSubtitle: 'F\u00f8rste erfaring & mestring',
      youngDesc: 'Studenter og unge voksne som vil gj\u00f8re en forskjell, f\u00e5 erfaring og oppleve mestring gjennom \u00e5 hjelpe andre.',
      youngFeatures: ['Meningsfull erfaring', 'Fleksibelt', 'Gj\u00f8re en forskjell'],
      familiesTitle: 'Familier',
      familiesSubtitle: 'Avlastning & mer tid',
      familiesDesc: 'Travle familier som trenger avlastning \u2014 med barnepass, \u00e6rend, husarbeid eller bare noen ekstra hender i hverdagen.',
      familiesFeatures: ['Barnepass & aktiviteter', 'Praktisk hjelp', 'Mer tid til familien'],
      eldersTitle: 'Eldre',
      eldersSubtitle: 'Hjelp, selskap & trygghet',
      eldersDesc: 'Seniorer som \u00f8nsker selskap, hjelp med daglige gj\u00f8rem\u00e5l, digital veiledning eller f\u00f8lge til avtaler.',
      eldersFeatures: ['Selskap & samv\u00e6r', 'Praktisk hjelp', 'Digital veiledning'],
      retiredTitle: 'Nypensjonerte & mentorer',
      retiredSubtitle: 'Del erfaring & gi mening',
      retiredDesc: 'Del erfaring, bli sett, og gi den yngre generasjonen et l\u00f8ft. Bidra med det du kan \u2014 p\u00e5 dine premisser.',
      retiredFeatures: ['Del livserfaring', 'Mentorskap', 'Mening i hverdagen'],
      servicesTitle: 'Det vi kan hjelpe med',
      servicesHeadline: 'Hva trenger du hjelp til?',
      servicesSubtitle: 'Fra selskap til teknisk hjelp \u2013 v\u00e5re hjelpere stiller opp n\u00e5r du trenger det.',
      groupsTitle: 'Sammen er det lettere',
      groupsHeadline: 'Sammen er det lettere \u00e5 bidra',
      groupsSubtitle: 'Hjelpere kan etter hvert g\u00e5 sammen i sm\u00e5 samlinger og grupper \u2014 for trygghet, fellesskap og mer mening.',
      groupsComingSoon: 'Mentor-ledede samlinger kommer',
      groupsPointSafety: 'Tryggere \u00e5 m\u00f8te opp sammen',
      groupsPointSocial: 'Mer sosialt og l\u00e6rerikt',
      groupsPointSupport: 'Del ansvar og bygg fellesskap',
      groupsCtaPrimary: 'Bli hjelper',
      groupsCtaSecondary: 'Hvordan funker det?',
      processTitle: 'Slik gj\u00f8r du det',
      processHeadline: 'Slik fungerer Vennli',
      step1Title: 'Lag en profil',
      step1Desc: 'Registrer deg som hjelper eller den som trenger hjelp. Fortell litt om deg selv.',
      step2Title: 'Finn noen som passer',
      step2Desc: 'Se hvem som er i n\u00e6rheten og finn noen du har lyst til \u00e5 m\u00f8te.',
      step3Title: 'Bli enige om pris',
      step3Desc: 'Avtal pris direkte mellom dere \u2014 p\u00e5 forh\u00e5nd, slik at det er klart for alle.',
      step4Title: 'Avtal og m\u00f8tes',
      step4Desc: 'Sett av tid og sted, m\u00f8t hverandre, og betal trygt gjennom Vennli.',
      opennessTitle: '\u00c6rlig og ekte',
      opennessHeadline: '\u00c6rlig og ekte \u2014 fra starten',
      opennessSubtitle: 'Vi bygger Vennli steg for steg. M\u00e5let er en varm m\u00f8teplass som gj\u00f8r Norge litt mer vennlig.',
      opennessCta: 'Finn hjelp',
      ctaBadge: 'Trygt \u2022 Lokalt \u2022 Vennli',
      footerText: 'En møteplass mellom generasjoner.',
      ungTitle: 'Under 18?',
      ungHeadline: 'Vennli Ung',
      ungSubtitle: 'Er du under 18 og vil bidra i nærmiljøet ditt? Meld din interesse, så gir vi deg beskjed når Vennli Ung er klart.',
      ungNameLabel: 'Navn',
      ungNamePlaceholder: 'Ditt fulle navn',
      ungBirthDateLabel: 'Fødselsdato',
      ungPostalCodeLabel: 'Postnummer',
      ungPostalCodePlaceholder: '0000',
      ungEmailLabel: 'E-post',
      ungEmailPlaceholder: 'din@epost.no',
      ungSubmit: 'Meld interesse',
      ungSubmitting: 'Sender...',
      ungSuccess: 'Takk! Vi gir deg beskjed når Vennli Ung er klart.',
      ungError: 'Noe gikk galt. Prøv igjen.',
      ungAlreadyRegistered: 'Denne e-postadressen er allerede registrert.',
      ungBadge: 'Kommer snart',
      paymentStripTitle: 'Slik fungerer betaling p\u00e5 Vennli',
      paymentStep1Title: 'Finn noen som passer',
      paymentStep1Desc: 'Se hjelpere i n\u00e6rheten og ta kontakt med den som virker riktig for deg.',
      paymentStep2Title: 'Bli enige om pris',
      paymentStep2Desc: 'Dere avtaler pris direkte \u2014 f\u00f8r dere m\u00f8tes.',
      paymentStep3Title: 'Betal trygt i Vennli',
      paymentStep3Desc: 'Betaling skjer gjennom Vennli. Enkelt og trygt for begge parter.',
      faqTitle: 'Vanlige sp\u00f8rsm\u00e5l',
      faqQ1: 'Koster det penger \u00e5 bruke Vennli?',
      faqA1: 'Ja, det meste av hjelpen p\u00e5 Vennli er betalt. Dere avtaler pris seg imellom \u2014 det er ingen fast prisliste. \u00c5 registrere seg er gratis.',
      faqQ2: 'Hvordan avtales pris?',
      faqA2: 'Hver hjelper kan sette sin egen pris, eller dere avtaler det som passer for begge. Pris bestemmes alltid p\u00e5 forh\u00e5nd \u2014 f\u00f8r dere m\u00f8tes.',
      faqQ3: 'Hvordan fungerer betaling?',
      faqA3: 'Betaling skjer trygt gjennom Vennli via Stripe. Pengene h\u00e5ndteres i plattformen, slik at det er trygt og enkelt for begge.',
    },
    stripeWizard: {
      step1Title: 'Slik får du betalt',
      step1Bullets: [
        'Vi bruker Stripe for trygge utbetalinger',
        'Privat bankkonto holder – ingen bedrift nødvendig',
        'Du trenger ikke organisasjonsnummer',
        'Tar bare 2–3 minutter å sette opp',
      ],
      step1Button: 'Fortsett',
      step2Title: 'Skatt & frikort (kort forklart)',
      step2Bullets: [
        'Inntekt via Vennli er skattepliktig',
        'Du kan bruke frikortgrensen din (100 000 kr i 2026)',
        'Vi viser oversikt over inntekt og frikort i appen',
        'Du er selv ansvarlig for å rapportere til skattemyndighetene',
      ],
      step2Disclaimer: 'Vennli gir ikke skatterådgivning. Kontakt Skatteetaten ved spørsmål.',
      step2Button: 'Ok – koble til Stripe',
      step3Title: 'Du sendes til Stripe',
      step3Desc: 'Stripe samler inn ID-verifisering og bankinformasjon. Du kan avbryte når som helst og komme tilbake senere.',
      step3Button: 'Åpne Stripe',
      stepIndicator: 'Steg {current} av {total}',
    },
    economy: {
      title: 'Økonomi',
      subtitle: 'Oversikt over inntekt, utbetalinger og skatt – enkelt og trygt.',
      stripeReady: 'Utbetalinger er klare',
      stripeReadyDesc: 'Stripe er satt opp og klart til bruk.',
      stripePending: 'Mangler oppsett',
      stripePendingDesc: 'Fullfør Stripe-oppsettet for å motta utbetalinger.',
      stripeSetup: 'Fullfør Stripe-oppsett',
      stripeNotStarted: 'Koble til utbetalinger',
      incomeTitle: 'Inntekt i år',
      helperAmount: 'Utbetalt til deg',
      platformContribution: 'Bidrag til Vennli',
      totalAmount: 'Totalt betalt av oppdragsgivere',
      meetingCount: 'Betalte møter',
      frikortTitle: 'Skatt & frikort',
      frikortLabel: 'Din frikortgrense',
      frikortProgress: '{amount} kr av {limit} kr brukt',
      frikortWarning: 'Du nærmer deg frikortgrensen. Vurder å sjekke skattekortet ditt.',
      frikortDisclaimer: 'Dette er ikke juridisk rådgivning – sjekk alltid Skatteetaten ved behov.',
      frikortSave: 'Lagre',
      frikortSaved: 'Lagret!',
      transactionsTitle: 'Transaksjoner',
      date: 'Dato',
      service: 'Tjeneste',
      seeker: 'Oppdragsgiver',
      amount: 'Til deg',
      contribution: 'Bidrag',
      status: 'Status',
      downloadCsv: 'Last ned inntektsrapport (CSV)',
      backToDashboard: 'Tilbake til kontrollpanel',
      noTransactions: 'Ingen betalte møter ennå.',
      kr: 'kr',
      paid: 'Betalt',
      seeEconomy: 'Se økonomi',
    },
    contact: {
      backToHome: 'Tilbake til forsiden',
      title: 'Vi er her for deg',
      subtitle: 'Har du spørsmål, tilbakemeldinger eller bare vil si hei? Vi svarer gjerne.',
      emailLabel: 'Send oss en e-post',
      emailHint: 'Vi svarer vanligvis innen en virkedag.',
      phoneLabel: 'Ring oss',
      phoneHint: 'Hverdager mellom 09:00 og 17:00.',
      warmNote: 'Vennli er bygget med varme. Vi setter pris på at du tar kontakt.',
      footerLink: 'Kontakt oss',
    },
    // Services/Categories
    services: {
      selskapSamvaer: 'Selskap & Samvær',
      selskapSamvaerDesc: 'Sosiale besøk, samtale og hyggelig selskap',
      aerendFolge: 'Ærend & Følge',
      aerendFolgeDesc: 'Handling, avtaler og følge til og fra',
      tekniskHjelp: 'Teknisk Hjelp',
      tekniskHjelpDesc: 'Hjelp med telefon, PC og digitale verktøy',
      hjemmehjelp: 'Hjemmehjelp',
      hjemmehjelpDesc: 'Lett rengjøring, rydding og huslige oppgaver',
      hageUte: 'Hage & Ute',
      hageUteDesc: 'Hagearbeid, plenklipping og uteområder',
      dyreomsorg: 'Dyreomsorg',
      dyreomsorgDesc: 'Passe dyr, lufting og dyrestell',
      barnepassLeksehjelp: 'Barnepass & Leksehjelp',
      barnepassLeksehjelpDesc: 'Barnepass, aktiviteter og leksehjelp',
      laeringDeling: 'Læring & Deling',
      laeringDelingDesc: 'Del kunnskap, lær noe nytt sammen',
      other: 'Annet',
      otherDesc: 'Har du noe annet å bidra med? Send oss et forslag',
      companionship: 'Selskap & Samvær',
      companionshipDesc: 'Sosiale besøk, samtale og hyggelig selskap',
      errands: 'Ærend & Følge',
      errandsDesc: 'Handling, avtaler og følge til og fra',
      techHelp: 'Teknisk Hjelp',
      techHelpDesc: 'Hjelp med telefon, PC og digitale verktøy',
      household: 'Hjemmehjelp',
      householdDesc: 'Lett rengjøring, rydding og huslige oppgaver',
    },
    // Auth
    auth: {
      welcomeBack: 'Velkommen tilbake',
      enterCredentials: 'Skriv inn påloggingsinformasjonen din',
      email: 'E-post',
      password: 'Passord',
      loggingIn: 'Logger inn...',
      noAccount: 'Har du ikke en konto?',
      signUp: 'Registrer deg',
      createAccount: 'Opprett Konto',
      joinCommunity: 'Bli med i vårt fellesskap av hjelpere og omsorgssøkere',
      iWantTo: 'Jeg ønsker å...',
      findHelp: 'Finne Hjelp',
      offerHelp: 'Tilby Hjelp',
      fullName: 'Fullt Navn',
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      phone: 'Telefonnummer',
      postalCode: 'Postnummer',
      creatingAccount: 'Oppretter konto...',
      hasAccount: 'Har du allerede en konto?',
      signIn: 'Logg inn',
      backToHome: 'Tilbake til forsiden',
      verifyEmailNote: 'E-post må bekreftes før kontoen er aktiv',
      emailAlreadyRegistered: 'Denne e-postadressen er allerede registrert. Prøv å logge inn i stedet.',
      passwordTooShort: 'Passordet m\u00e5 v\u00e6re minst 8 tegn.',
      registrationFailed: 'Noe gikk galt. Vennligst pr\u00f8v igjen.',
      forgotPassword: 'Glemt passord?',
      forgotPasswordTitle: 'Tilbakestill passord',
      forgotPasswordDesc: 'Skriv inn e-postadressen din, s\u00e5 sender vi deg en lenke for \u00e5 velge nytt passord.',
      sendResetLink: 'Send tilbakestillingslenke',
      sending: 'Sender...',
      resetLinkSent: 'Hvis en konto med denne e-postadressen finnes, har vi sendt en lenke.',
      backToLogin: 'Tilbake til innlogging',
      resetPasswordTitle: 'Velg nytt passord',
      resetPasswordDesc: 'Skriv inn ditt nye passord nedenfor.',
      newPassword: 'Nytt passord',
      confirmPassword: 'Bekreft passord',
      resetPassword: 'Lagre nytt passord',
      resetting: 'Lagrer...',
      passwordResetSuccess: 'Passordet er tilbakestilt! Du kan n\u00e5 logge inn.',
      passwordsDoNotMatch: 'Passordene stemmer ikke overens.',
      invalidResetLink: 'Ugyldig eller utl\u00f8pt tilbakestillingslenke.',
    },
    // Helpers page
    helpers: {
      title: 'Finn Din Hjelper',
      subtitle: 'Oppdag pålitelige hjelpere i ditt nærområde',
      searchPlaceholder: 'Søk etter hjelpere...',
      filterByService: 'Tjenestetype',
      filterLocation: 'Sted',
      filterRate: 'Maks pris',
      locationPlaceholder: 'Skriv by eller postnr...',
      allServices: 'Alle Tjenester',
      newHelper: 'Ny',
      noHelpers: 'Ingen hjelpere funnet',
      loading: 'Laster hjelpere...',
      viewProfile: 'Se Profil',
      perHour: 'per time',
      reviews: 'Anmeldelser',
      verified: 'Verifisert',
      available: 'Tilgjengelig',
      groupAvailable: 'Tilgjengelig som gruppe',
      groupSafety: 'Tryggere',
      groupSocial: 'Sosialt',
      viewGroup: 'Se gruppe',
      groupCtaTitle: 'Vil du jobbe sammen?',
      groupCtaSubtitle: 'Opprett eller bli med i en gruppe for tryggere og mer sosiale oppdrag.',
      groupCtaButton: 'Opprett eller bli med',
      groupCtaView: 'Se min gruppe',
      backToHelpers: 'Tilbake til Hjelpere',
      notFound: 'Hjelper ikke funnet',
    },
    // Helper Profile
    helperProfile: {
      about: 'Om',
      servicesOffered: 'Tjenester Som Tilbys',
      reviews: 'Anmeldelser',
      bookNow: 'Be om hjelp',
      contact: 'Kontakt',
      memberSince: 'Medlem siden',
      noReviews: 'Ingen anmeldelser ennå',
      hourlyRate: 'Timepris',
      serviceListings: 'Tilbud',
      activeListings: 'Aktive Tilbud',
    },
    // Groups page
    groups: {
      title: 'Hjelpergrupper',
      subtitle: 'Finn grupper av hjelpere som jobber sammen',
      bannerTitle: 'Tilby tjenester sammen',
      bannerSubtitle: 'Bli med eller opprett en gruppe for å tilby tjenester sammen. Det er tryggere, mer sosialt og en flott måte å møte nye mennesker på.',
      bannerSafer: 'Tryggere',
      bannerSocial: 'Sosialt',
      bannerExperience: 'Erfaring',
      filterServiceLabel: 'Tjenestetype',
      filterRateLabel: 'Makspris',
      allServices: 'Alle Tjenester',
      anyRate: 'Alle priser',
      noGroupsTitle: 'Ingen grupper ennå',
      noGroupsCta: 'Bli den første til å opprette en hjelpergruppe!',
      myGroup: 'Min Gruppe',
      yourGroupBadge: 'Din Gruppe',
      joining: 'Sender...',
      join: 'Bli kjent',
      requestSent: 'Forespørsel sendt',
      alreadyMember: 'Du er med',
      searchPlaceholder: 'Søk etter grupper...',
      createGroup: 'Opprett en Gruppe',
      noGroups: 'Ingen grupper funnet',
      loading: 'Laster grupper...',
      viewGroup: 'Se Gruppe',
      members: 'medlemmer',
      member: 'Medlem',
      groupRate: 'Gruppepris',
      joinForces: 'Slå deg sammen med andre hjelpere for større oppdrag',
      joinModeRequest: 'Med godkjenning',
      joinModeInviteOnly: 'Kun invitasjon',
    },
    groupDetail: {
      groupDetails: 'Gruppedetaljer',
      backToGroups: 'Tilbake til Grupper',
      groupMembers: 'Gruppemedlemmer',
      leader: 'Leder',
      joined: 'Ble med',
      joinGroup: 'Bli Med i Gruppen',
      leaveGroup: 'Forlat Gruppen',
      bookGroup: 'Bestill Gruppen',
      specialties: 'Spesialiteter',
      deleteGroup: 'Slett Gruppe',
      editGroup: 'Rediger Gruppe',
      deleteTitle: 'Slette denne gruppen?',
      deleteDescription: 'Denne handlingen kan ikke angres. Alle medlemmer fjernes fra gruppen.',
      coverPhoto: 'Forsidebilde',
      uploadCoverPhoto: 'Last opp forsidebilde',
      changeCoverPhoto: 'Endre forsidebilde',
      removeCoverPhoto: 'Fjern forsidebilde',
      noReviews: 'Ingen anmeldelser ennå',
      bookingSubtitle: 'Planlegg en økt med denne hjelpergruppen ({count} medlemmer)',
      rateLabel: 'Pris',
      groupHelpersLabel: 'Gruppe med {count} hjelpere',
      continuePayment: 'Fortsett til betaling',
      creatingBooking: 'Oppretter bestilling...',
      membershipTitle: 'Medlemskap',
      membershipRequest: 'Gruppeleder godkjenner nye medlemmer',
      membershipInviteOnly: 'Kun med invitasjon fra gruppeleder',
      membershipSafe: 'Vi vil at grupper skal føles trygge og ekte. Start med å si hei',
      requestToJoin: 'Send forespørsel',
      contactFirst: 'Ta kontakt først',
      requestPlaceholder: 'Si hei — hvorfor vil du bli med?',
      sendRequest: 'Send forespørsel om å bli med',
      sending: 'Sender...',
      requestPending: 'Forespørsel sendt',
      requestPendingNote: 'Gruppeleder vurderer forespørselen din',
      requestApproved: 'Forespørsel godkjent!',
      requestRejected: 'Forespørselen ble ikke godkjent',
      leaderReply: 'Svar fra gruppeleder',
      pendingRequests: 'Forespørsler',
      noPendingRequests: 'Ingen ventende forespørsler',
      approve: 'Godkjenn',
      reject: 'Avslå',
      replyToRequest: 'Svar',
      replyPlaceholder: 'Skriv en kort melding...',
      inviteByEmail: 'Inviter via e-post',
      inviteEmailPlaceholder: 'navn@eksempel.no',
      inviteMessagePlaceholder: 'Personlig hilsen (valgfritt)',
      sendInvite: 'Send invitasjon',
      sendingInvite: 'Sender...',
      inviteSent: 'Invitasjon sendt!',
      pendingInvites: 'Invitasjoner',
      noPendingInvites: 'Ingen ventende invitasjoner',
      inviteStatus: 'Status',
      invitePending: 'Venter',
      inviteAccepted: 'Godtatt',
      inviteExpired: 'Utløpt',
      joinModeLabel: 'Tilgangstype',
      joinModeRequest: 'Med godkjenning (anbefalt)',
      joinModeInviteOnly: 'Kun invitasjon (tryggest)',
      leaderControls: 'Gruppeleder',
      acceptInviteTitle: 'Godta invitasjon',
      acceptInviteDesc: 'Du er invitert til å bli med i denne gruppen.',
      acceptInvite: 'Godta invitasjon',
      accepting: 'Godtar...',
    },
    groupCreate: {
      title: 'Opprett en Gruppe',
      subtitle: 'Start en hjelpergruppe og inviter andre til å bli med',
      nameLabel: 'Gruppenavn',
      namePlaceholder: 'F.eks. Campus-hjelpere, Nabolagslaget',
      descriptionLabel: 'Beskrivelse',
      descriptionPlaceholder: 'Fortell omsorgssøkere om gruppen...',
      servicesLabel: 'Tjenester som tilbys',
      rateLabel: 'Timepris for gruppe',
      rateHelp: 'Grupper tar ofte lavere priser, noe som gjør tjenestene mer tilgjengelige',
      createButton: 'Opprett Gruppe',
      creating: 'Oppretter...',
      joinModeLabel: 'Hvem kan bli med?',
      joinModeRequest: 'Med godkjenning (anbefalt)',
      joinModeInviteOnly: 'Kun invitasjon (tryggest)',
    },
    // Jobs page
    jobs: {
      title: 'Oppdragstavle',
      subtitle: 'Se tilgjengelige oppdrag fra omsorgssøkere',
      helperSubtitle: 'Finn oppdrag fra omsorgssøkere som trenger hjelp',
      careSeekerSubtitle: 'Legg ut et oppdrag og få hjelp fra fellesskapet',
      searchPlaceholder: 'Søk etter oppdrag...',
      postJob: 'Legg ut et Oppdrag',
      bannerTitle: 'Bla gjennom tilgjengelige oppdrag',
      bannerSubtitle: 'Omsorgssøkere legger ut oppdrag de trenger hjelp med. Søk på oppdrag som matcher ferdighetene dine.',
      filterServiceLabel: 'Tjenestetype',
      filterUrgencyLabel: 'Hastegrad',
      allServices: 'Alle Tjenester',
      anyUrgency: 'Alle hastegrader',
      noJobsTitle: 'Ingen oppdrag ennå',
      noJobsCareSeeker: 'Vær den første til å legge ut et oppdrag!',
      noJobsHelper: 'Kom tilbake senere for nye muligheter',
      noJobs: 'Ingen oppdrag funnet',
      loading: 'Laster oppdrag...',
      viewDetails: 'Se Detaljer',
      budget: 'Budsjett',
      urgency: 'Hastegrad',
      urgent: 'Haster',
      thisWeek: 'Denne uken',
      flexible: 'Fleksibel',
      applications: 'søknader',
      postedBy: 'Lagt ut av',
      open: 'Åpen',
      inProgress: 'Pågår',
      completed: 'Fullført',
    },
    // Job Detail
    jobDetail: {
      jobDetails: 'Oppdragsdetaljer',
      backToJobs: 'Tilbake til Oppdrag',
      deleteTitle: 'Slette dette oppdraget?',
      deleteDescription: 'Dette vil permanent slette oppdraget og alle søknader.',
      deleteConfirm: 'Slett',
      descriptionTitle: 'Beskrivelse',
      budgetTitle: 'Budsjett',
      mediaTitle: 'Bilder og Videoer',
      addMedia: 'Legg til',
      mediaEmpty: 'Ingen media lastet opp ennå',
      applicationsEmpty: 'Ingen søknader ennå',
      applicantGroup: 'Gruppe',
      applicantHelper: 'Individuell hjelper',
      applyCardTitle: 'Interessert i dette oppdraget?',
      applyCardSubtitle: 'Søk nå og gi oppdragsgiver beskjed om at du kan hjelpe!',
      applyNow: 'Søk Nå',
      yourApplication: 'Din Søknad',
      coverLetter: 'Søknadsbrev',
      proposedRate: 'Foreslått Pris',
      submitApplication: 'Send Søknad',
      applyDialogTitle: 'Søk på Oppdrag',
      applyDialogSubtitle: 'Fortell hvorfor du passer godt til oppdraget',
      applyMessageLabel: 'Din melding',
      applyMessagePlaceholder: 'Presenter deg selv og forklar hvorfor du passer for oppdraget...',
      applyRateLabel: 'Foreslått Pris (Valgfritt)',
      applyRatePlaceholder: 'Din pris',
      applySubmitting: 'Sender...',
      alreadyApplied: 'Du har allerede søkt',
      applicationsTitle: 'Søknader',
      accept: 'Godta',
      reject: 'Avslå',
      accepted: 'Godtatt',
      rejected: 'Avslått',
      pending: 'Ventende',
      postedByLabel: 'Lagt ut av',
      postedRole: 'Omsorgssøker',
    },
    // Create Job
    createJob: {
      title: 'Legg Ut et Nytt Oppdrag',
      subtitle: 'Beskriv oppdraget du trenger hjelp med',
      jobTitle: 'Oppdrags-tittel',
      jobTitlePlaceholder: 'F.eks. Hjelp med hagearbeid',
      description: 'Beskrivelse',
      descriptionPlaceholder: 'Beskriv oppdraget i detalj...',
      descriptionHelp: 'Jo flere detaljer, desto bedre treff får du',
      serviceType: 'Tjenestetype',
      selectService: 'Velg en tjeneste',
      budgetRange: 'Budsjettramme',
      minimum: 'Minimum',
      maximum: 'Maksimum',
      location: 'Sted',
      locationPlaceholder: 'F.eks. Oslo, Norge',
      urgencyLevel: 'Hastegrad',
      urgencyPrompt: 'Hvor raskt trenger du dette utført?',
      addMedia: 'Legg Til Bilder eller Video',
      mediaHelp: 'Legg til bilder eller video for å forklare oppdraget bedre',
      mediaUploadCta: 'Klikk for å laste opp bilder eller video',
      mediaSupported: 'Støtter JPEG, PNG, GIF, WebP, MP4, MOV, WebM. Maks 50MB per fil.',
      postJob: 'Legg Ut Oppdrag',
      posting: 'Legger ut...',
    },
    // Services Listings page
    serviceListings: {
      title: 'Tilbud',
      subtitle: 'Se tilbud fra våre hjelpere',
      searchPlaceholder: 'Søk etter tilbud...',
      listService: 'Legg ut tilbud',
      noServices: 'Ingen tjenester funnet',
      loading: 'Laster tjenester...',
      viewService: 'Se Tjeneste',
      remoteAvailable: 'Fjernhjelp Tilgjengelig',
      groupService: 'Gruppetjeneste',
      filterByCategory: 'Filtrer etter kategori',
      allCategories: 'Alle Kategorier',
      priceRange: 'Prisområde',
      remoteOnly: 'Kun fjernhjelp',
    },
    // Service Listing Detail
    serviceDetail: {
      serviceDetails: 'Tjenestedetaljer',
      offeredBy: 'Tilbudt av',
      bookService: 'Avtal et møte',
      editService: 'Rediger tilbud',
      deleteService: 'Slett tilbud',
      deleteConfirmTitle: 'Slette dette tilbudet?',
      activeLabel: 'Aktiv (synlig for andre)',
      price: 'Pris',
      perHour: 'per time',
      fixedPrice: 'fast pris',
      startingAt: 'fra',
      duration: 'Varighet',
      category: 'Kategori',
      tags: 'Stikkord',
      remote: 'Fjernhjelp',
      yes: 'Ja',
      no: 'Nei',
      backToServices: 'Tilbake til tjenester',
      addMedia: 'Legg til bilder/videoer',
      aboutService: 'Om denne tjenesten',
      groupService: 'Gruppetjeneste',
      inactive: 'Inaktiv',
      saveChanges: 'Lagre endringer',
      loginToBook: 'Logg inn for å bestille',
      viewGroupProfile: 'Se gruppeprofil',
      bookings: 'Bestillinger',
      listed: 'Opprettet',
      rating: 'vurdering',
    },
    // Create Service Listing
    servicesPage: {
      title: 'Tjenester',
      subtitle: 'Oppdag unike tjenester tilbudt av våre hjelpere',
      searchPlaceholder: 'Søk etter tjenester...',
      search: 'Søk',
      category: 'Kategori',
      allCategories: 'Alle Kategorier',
      maxPrice: 'Maks pris',
      anyPrice: 'Alle priser',
      upTo: 'Opp til',
      remoteOnly: 'Kun fjernhjelp',
      groupServices: 'Gruppetjenester',
      listService: 'Legg ut tilbud',
      group: 'Gruppe',
    },
    createService: {
      title: 'Fortell hvordan du kan bidra',
      subtitle: 'Beskriv hva du kan tilby, så finner vi noen som trenger akkurat deg',
      serviceTitle: 'Tittel',
      serviceTitlePlaceholder: 'F.eks. Hyggelig selskap og en kopp kaffe',
      description: 'Beskrivelse',
      descriptionPlaceholder: 'Fortell litt om hva du kan bidra med. Hva liker du å gjøre? Hvordan kan du gjøre noens dag bedre?',
      category: 'Kategori',
      selectCategory: 'Velg en kategori',
      categoryHelperText: 'Velg det som passer best. Handler det om noe annet? Send oss et forslag 💛',
      customCategoryPlaceholder: 'Beskriv kort hva du kan bidra med (maks 120 tegn)',
      pendingNotice: 'Takk for forslaget! Vi ser på det og gjør det synlig så snart som mulig.',
      pricingType: 'Pristype',
      hourly: 'Per time',
      fixed: 'Fast pris',
      startingAt: 'Fra',
      price: 'Pris',
      durationEstimate: 'Estimert varighet',
      durationPlaceholder: 'F.eks. 1-2 timer, halv dag, varierer',
      location: 'Sted',
      locationPlaceholder: 'By, område eller «Hos deg»',
      remoteService: 'Fjernhjelp tilgjengelig',
      tags: 'Stikkord',
      tagsPlaceholder: 'Skriv inn og trykk enter for å legge til',
      tagsHelp: 'Legg til opptil 5 stikkord for å hjelpe folk med å finne tilbudet ditt',
      addMedia: 'Legg til bilder eller video',
      mediaHelp: 'Vis eksempler på arbeidet ditt eller deg selv i aksjon',
      uploadMedia: 'Last opp bilder eller videoer',
      uploading: 'Laster opp...',
      uploadHelp: 'Støtter JPEG, PNG, GIF, WebP, MP4, MOV, WebM. Maks 50 MB per fil.',
      createListing: 'Legg ut tilbud',
      listMyService: 'Legg ut tilbud',
      creating: 'Oppretter...',
      backToServices: 'Tilbake til tilbud',
      groupNotice: 'Dette tilbudet vil bli listet under gruppen din:',
      groupMember: 'Du er medlem av',
      groupServiceToggle: 'Gruppetilbud',
      listedAsGroup: 'Tilbudet listes som en del av gruppen din',
      listedAsIndividual: 'Tilbudet listes som ditt eget, ikke gruppens',
      optional: 'Valgfritt',
    },
    // Dashboard
    dashboard: {
      title: 'Kontrollpanel',
      welcomeBack: 'Godt \u00e5 se deg',
      helperSubtitle: 'Her har du oversikt over m\u00f8tene dine \u2014 og hvordan du kan bidra.',
      seekerSubtitle: 'Her har du oversikt over m\u00f8tene dine og hjelperne du har funnet.',
      yourStats: 'Din Statistikk',
      totalBookings: 'M\u00f8ter avtalt',
      pendingBookings: 'Venter svar',
      completedBookings: 'Gjennomf\u00f8rt',
      totalEarnings: 'Tjent s\u00e5 langt',
      yourProfile: 'Din Profil',
      profileDna: 'Vennli handler om verdighet \u2014 \u00e5 hjelpe, og bli sett.',
      editProfile: 'Rediger Profil',
      saveChanges: 'Lagre Endringer',
      saving: 'Lagrer...',
      bio: 'Om meg',
      bioPlaceholder: 'Fortell litt om deg selv...',
      location: 'Sted',
      locationPlaceholder: 'F.eks. Oslo, Norge',
      hourlyRate: 'Timepris',
      phone: 'Telefon',
      phonePlaceholder: '+47 xxx xx xxx',
      available: 'Tilgjengelig for m\u00f8ter',
      servicesYouOffer: 'Det du kan bidra med',
      recentBookings: 'Nylige m\u00f8ter',
      viewAll: 'Se Alle',
      noBookings: 'Ingen m\u00f8ter enda \u2014 men det kommer \uD83D\uDC9B',
      noBookingsTip: 'Tips: Start med \u00abSelskap & Samv\u00e6r\u00bb eller \u00ab\u00c6rend & F\u00f8lge\u00bb for \u00e5 komme i gang.',
      yourGroup: 'Fellesskapet ditt',
      viewMyGroup: 'Se fellesskapet',
      groupHint: 'Grupper gj\u00f8r det tryggere og mer sosialt \u00e5 bidra.',
      groupComingSoon: 'Mentor-ledede samlinger kommer \u2728',
      notInGroup: 'Du er ikke med i et fellesskap enn\u00e5',
      browseGroups: 'Utforsk fellesskap',
      yourListings: 'Dine tilbud',
      createListing: 'Legg ut hvordan jeg kan bidra',
      noListings: 'Du har ingen tilbud enn\u00e5',
      quickActions: 'Kom i gang',
      browseHelpers: 'Finn Hjelpere',
      viewBookings: 'Se mine m\u00f8ter',
      allSet: 'Alt klart for f\u00f8rste m\u00f8te \u2728',
      helperEmptyHint: 'Legg ut hvordan du kan bidra \u2014 eller utforsk folk som trenger en h\u00e5nd i n\u00e6romr\u00e5det.',
      seekerEmptyHint: 'Utforsk hjelpere i n\u00e6rheten, eller legg ut en foresp\u00f8rsel for \u00e5 finne riktig match.',
      browseJobs: 'Se foresp\u00f8rsler',
      currency: 'kr',
      perHour: '/t',
    },
    // Bookings page
    bookings: {
      title: 'Mine Bestillinger',
      subtitle: 'Administrer dine bestillinger',
      helperSubtitle: 'Administrer dine tjenesteforespørsler',
      seekerSubtitle: 'Hold oversikt over dine bestilte tjenester',
      allBookings: 'Alle Bestillinger',
      upcoming: 'Kommende',
      past: 'Tidligere',
      noBookings: 'Ingen bestillinger funnet',
      loading: 'Laster bestillinger...',
      viewBooking: 'Se Bestilling',
      with: 'med',
      group: 'Gruppe',
      openRequest: 'Åpen forespørsel',
      flexibleRequest: 'Fleksibel forespørsel',
    },
    // Booking Detail
    bookingDetail: {
      bookingDetails: 'Bestillingsdetaljer',
      backToBookings: 'Tilbake til Bestillinger',
      service: 'Tjeneste',
      dateTime: 'Dato og Tid',
      duration: 'Varighet',
      totalAmount: 'Totalt Beløp',
      paymentStatus: 'Betalingsstatus',
      bookingStatus: 'Bestillingsstatus',
      payNow: 'Betal Nå',
      confirmBooking: 'Bekreft Bestilling',
      cancelBooking: 'Avbestill',
      completeBooking: 'Fullfør Bestilling',
      leaveReview: 'Legg Igjen en Anmeldelse',
      leaveReviewHelper: 'Vurder hjelperen',
      leaveReviewSeeker: 'Vurder omsorgssøker',
      notes: 'Notater',
      helper: 'Hjelper',
      careSeeker: 'Omsorgssøker',
      groupMembers: 'Gruppemedlemmer',
      groupBooking: 'Gruppebestilling',
      groupHelpers: 'Hjelpere i denne gruppen',
      openRequest: 'Åpen forespørsel',
      openRequestNote: 'Tidspunkt avtales direkte i chatten',
      rating: 'Vurdering',
      comment: 'Kommentar',
      submitReview: 'Send Anmeldelse',
      reviewTitle: 'Legg Igjen en Anmeldelse',
      reviewTitleHelper: 'Vurder hjelperen',
      reviewTitleSeeker: 'Vurder omsorgssøker',
      reviewFor: 'Del opplevelsen din med {name}.',
      reviewHiddenNote: 'Vurderingen blir synlig når begge har vurdert.',
      reviewPlaceholder: 'Fortell om opplevelsen din...',
      submittingReview: 'Sender...',
      viewCareSeekerProfile: 'Se omsorgssøkerprofil',
      meetingLabel: 'Møte',
      platformContribution: 'Bidrag til Vennli',
      totalLabel: 'Totalt',
      goToPayment: 'Gå til betaling',
      paymentRequired: 'Betaling må fullføres før du kan gi en vurdering',
      waitingForApproval: 'Venter på godkjenning fra hjelper',
      approveBooking: 'Godkjenn',
      declineBooking: 'Avslå',
      approveConfirmTitle: 'Godkjenn oppdrag?',
      approveConfirmDescription: 'Når du godkjenner, kan oppdragsgiver betale for møtet.',
      declineConfirmTitle: 'Avslå oppdrag?',
      declineConfirmDescription: 'Er du sikker på at du vil avslå dette oppdraget?',
      markCompleted: 'Marker som utført',
      bookingCompleted: 'Oppdrag utført',
      contributionTooltipTitle: 'Bidrag til Vennli',
      contributionTooltipBody: 'Dette betales av den som bestiller. Bidraget hjelper oss å holde Vennli levende – en møteplass som gjør det enklere å hjelpe, og bli sett.',
      thankYouContribution: 'Takk for at du bidrar til et varmere lokalsamfunn.',
      safePaymentTitle: 'Slik fungerer trygg betaling',
      safePaymentStep1: 'Betalingen bekrefter at pengene er tilgjengelige',
      safePaymentStep2: 'Når oppdraget er utført, blir det gjort klart for utbetaling',
      safePaymentStep3: 'Du kan alltid kontakte oss hvis noe ikke ble som avtalt',
    },
    stripeConnect: {
      payoutsTitle: 'Utbetalinger',
      connectButton: 'Koble til utbetalinger (Stripe)',
      resumeButton: 'Fullfør oppsett',
      readyMessage: 'Utbetalinger er klare',
      readyDescription: 'Du er klar til å motta betaling for dine tjenester via Vennli.',
      connectDescription: 'Koble til Stripe for å motta utbetalinger trygt og enkelt.',
      pendingDescription: 'Oppsettet ditt er nesten klart. Fullfør det siste steget hos Stripe.',
      onboardingReturnTitle: 'Stripe-oppsett',
      onboardingReturnComplete: 'Oppsettet er fullført! Du er nå klar til å motta utbetalinger.',
      onboardingReturnPending: 'Oppsettet er nesten ferdig. Du må kanskje fullføre noen flere steg.',
      onboardingRefreshTitle: 'Prøv igjen',
      onboardingRefreshDescription: 'Lenken har utløpt. Klikk under for å få en ny lenke.',
      getNewLink: 'Få ny lenke',
      backToDashboard: 'Tilbake til kontrollpanelet',
      loading: 'Sjekker status...',
    },
    careSeekerProfile: {
      title: 'Omsorgssøkerprofil',
      subtitle: 'Tilbakemeldinger fra hjelpere',
      reviewsTitle: 'Anmeldelser',
      noReviews: 'Ingen anmeldelser ennå',
      memberSince: 'Medlem siden',
    },
    // Booking Form
    bookingForm: {
      bookHelper: 'Bestill Hjelper',
      bookGroup: 'Bestill Gruppe',
      selectService: 'Velg Tjeneste',
      selectDate: 'Velg Dato',
      selectTime: 'Velg Tidspunkt',
      duration: 'Varighet (timer)',
      notes: 'Tilleggsnotater',
      notesPlaceholder: 'Eventuelle spesielle ønsker eller informasjon...',
      totalCost: 'Totalkostnad',
      confirmBooking: 'Bekreft Bestilling',
      booking: 'Bestiller...',
      openRequestLabel: 'Åpen forespørsel',
      openRequestHint: 'La dato og tid stå åpne og avtal senere i chat',
      noAvailableTimes: 'Ingen tilgjengelige tider',
      availabilityHint: 'Velg en dato for å se tilgjengelige tider',
    },
    messaging: {
      title: 'Meldinger',
      subtitle: 'Koordiner detaljer for denne bestillingen',
      empty: 'Ingen meldinger ennå',
      inputPlaceholder: 'Skriv en melding...',
      send: 'Send',
      sending: 'Sender...',
      attach: 'Legg ved',
      attachments: 'Vedlegg',
      removeAttachment: 'Fjern vedlegg',
    },
    notifications: {
      title: 'Varsler',
      subtitle: 'Følg opp nye meldinger og statusendringer',
      empty: 'Ingen varsler ennå',
      markAllRead: 'Marker alle som lest',
      messageTitle: 'Ny melding',
      bookingTitle: 'Booking oppdatert',
      paymentTitle: 'Betaling mottatt',
      messageBody: '{sender} sendte en ny melding',
      bookingBody: 'Bookingstatus er nå {status}',
      paymentBody: 'Betaling mottatt: {amount}',
      viewBooking: 'Se bestilling',
    },
    notificationSettings: {
      title: 'Varslingsinnstillinger',
      subtitle: 'Velg hvordan du vil varsles',
      inAppLabel: 'In-app varsler',
      inAppHint: 'Vis varsler inne i Vennli',
      emailLabel: 'E-postvarsler',
      emailHint: 'E-post sendes når leverandør er valgt',
      save: 'Lagre innstillinger',
      saving: 'Lagrer...',
    },
    availability: {
      title: 'Tilgjengelighet',
      subtitle: 'Sett din faste ukeplan og legg til unntak for enkeltdager',
      onlyHelpers: 'Kun hjelpere kan administrere tilgjengelighet.',
      weekdays: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn'],
      weekdaysFull: ['Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag', 'Søndag'],
      slots: 'tider',
      dayHint: 'Velg timer du er tilgjengelig denne dagen.',
      addSlots: 'Legg til tidsblokker',
      start: 'Start',
      end: 'Slutt',
      addButton: 'Legg til timer',
      availableSlots: 'Tilgjengelige timer',
      clearDay: 'Tøm dagen',
      noSlots: 'Ingen tider lagt til ennå',
      invalidRange: 'Velg en gyldig tidsperiode',
      defaultSchedule: 'Fast ukeplan',
      defaultScheduleHint: 'Sett timene du vanligvis er tilgjengelig hver uke. Disse gjelder automatisk for alle fremtidige uker.',
      saveDefaults: 'Lagre ukeplan',
      savingDefaults: 'Lagrer...',
      defaultsSaved: 'Ukeplan lagret',
      available: 'Tilgjengelig',
      notSet: 'Ikke satt',
      exceptions: 'Unntak',
      exceptionsHint: 'Klikk på en dag for å overstyre standard-timeplanen for den dagen.',
      isDefault: 'Standard',
      isOverride: 'Egendefinert',
      isBlocked: 'Blokkert',
      resetToDefault: 'Tilbakestill til standard',
      blockDay: 'Blokker denne dagen',
      overrideDay: 'Egendefinerte timer',
    },
    admin: {
      title: 'Adminpanel',
      subtitle: 'Administrer plattformen',
      refresh: 'Oppdater',
      noAccess: 'Du har ikke tilgang til adminpanel.',
      delete: 'Slett',
      view: 'Se',
      deleteConfirm: 'Er du sikker på at du vil slette dette?',
      tabs: {
        users: 'Brukere',
        bookings: 'Bookinger',
        jobs: 'Jobber',
        groups: 'Grupper',
        listings: 'Tilbud',
        payments: 'Betalinger',
      },
      kpi: {
        totalUsers: 'Totale brukere',
        helpers: 'Hjelpere',
        seekers: 'Omsorgssøkere',
        bookings: 'Bookinger',
        jobs: 'Jobber',
        groups: 'Grupper',
        listings: 'Tilbud',
        payments: 'Betalinger',
      },
      userName: 'Navn',
      userEmail: 'E-post',
      userRole: 'Rolle',
      createdAt: 'Opprettet',
      roles: {
        helper: 'Hjelper',
        seeker: 'Omsorgssøker',
        admin: 'Admin',
      },
      bookingId: 'ID',
      bookingService: 'Tjeneste',
      bookingSchedule: 'Tidspunkt',
      bookingStatus: 'Status',
      bookingPayment: 'Betaling',
      jobTitle: 'Oppdrag',
      jobBudget: 'Budsjett',
      groupName: 'Gruppe',
      groupMembers: 'Medlemmer',
      listingTitle: 'Tjeneste',
      listingPrice: 'Pris',
      paymentId: 'Betaling',
      paymentBooking: 'Booking',
      paymentAmount: 'Beløp',
      paymentStatus: 'Status',
      createdBy: 'Opprettet av',
    },
    // Common
    common: {
      perHour: 'per time',
      reviews: 'Anmeldelser',
      new: 'Ny',
      status: 'Status',
      availableLabel: 'Tilgjengelig',
      unavailableLabel: 'Utilgjengelig',
      date: 'Dato',
      time: 'Tid',
      duration: 'Varighet',
      notes: 'Notater',
      optional: 'Valgfritt',
      notesPlaceholder: 'Eventuelle spesielle ønsker eller detaljer...',
      someone: 'Noen',
      markAsRead: 'Marker som lest',
      viewProfile: 'Se Profil',
      viewDetails: 'Se Detaljer',
      bookNow: 'Be om hjelp',
      loading: 'Laster...',
      noResults: 'Ingen resultater funnet',
      search: 'Søk',
      filter: 'Filtrer',
      clear: 'Tøm',
      all: 'Alle',
      save: 'Lagre',
      cancel: 'Avbryt',
      edit: 'Rediger',
      delete: 'Slett',
      submit: 'Send',
      confirm: 'Bekreft',
      back: 'Tilbake',
      next: 'Neste',
      close: 'Lukk',
      confirmed: 'bekreftet',
      pending: 'ventende',
      completed: 'fullført',
      cancelled: 'avbestilt',
      open: 'åpen',
      approved: 'godkjent',
      declined: 'avslått',
      inProgress: 'pågår',
      paid: 'betalt',
      unpaid: 'ubetalt',
      hours: 'timer',
      member: 'Medlem',
      members: 'medlemmer',
      from: 'fra',
      to: 'til',
      upTo: 'Opp til',
      or: 'eller',
      and: 'og',
      yes: 'Ja',
      no: 'Nei',
      group: 'Gruppe',
      individualHelper: 'Individuell hjelper',
      posted: 'Lagt ut',
      media: 'Media',
      processing: 'Behandler...',
      uploading: 'Laster opp...',
      saving: 'Lagrer...',
      kr: 'kr',
      nok: 'NOK',
    },
    categories: {
      selskapSamvaer: 'Selskap & Samvær',
      aerendFolge: 'Ærend & Følge',
      tekniskHjelp: 'Teknisk Hjelp',
      hjemmehjelp: 'Hjemmehjelp',
      hageUte: 'Hage & Ute',
      dyreomsorg: 'Dyreomsorg',
      barnepassLeksehjelp: 'Barnepass & Leksehjelp',
      laeringDeling: 'Læring & Deling',
      other: 'Annet (Send forslag)',
      companionship: 'Selskap & Samvær',
      errands: 'Ærend & Følge',
      techHelp: 'Teknisk Hjelp',
      household: 'Hjemmehjelp',
    },
    // Errors & Messages
    messages: {
      success: 'Suksess!',
      error: 'Noe gikk galt',
      notFound: 'Fant ikke informasjonen.',
      saved: 'Lagret',
      deleted: 'Slettet',
      updated: 'Oppdatert',
      created: 'Opprettet',
      bookingConfirmed: 'Bestilling bekreftet',
      paymentSuccess: 'Betaling vellykket',
      paymentExpired: 'Betalingssesjonen er utløpt',
      paymentTimeout: 'Betalingsstatus tok for lang tid. Oppdater siden.',
      applicationSent: 'Søknad sendt',
      reviewSubmitted: 'Anmeldelse sendt',
      profileUpdated: 'Profil oppdatert',
      listingCreated: 'Tilbud lagt ut',
      jobPosted: 'Oppdrag lagt ut',
      groupCreated: 'Gruppe opprettet',
      joinedGroup: 'Du ble med i gruppen',
      loginRequired: 'Vennligst logg inn',
      onlyHelpers: 'Bare hjelpere kan utføre denne handlingen',
      alreadyInGroup: 'Du er allerede medlem av en gruppe',
      groupNameRequired: 'Vennligst skriv inn et gruppenavn',
      serviceRequired: 'Velg minst én tjeneste',
      messageRequired: 'Vennligst skriv en melding',
      jobTitleRequired: 'Vennligst skriv inn en oppdragstittel',
      jobDescriptionRequired: 'Vennligst beskriv oppdraget',
      onlyCareSeeker: 'Kun omsorgssøkere kan legge ut oppdrag',
      onlyCareSeekerBooking: 'Bare omsorgssøkere kan bestille grupper',
      uploadSuccess: 'Opplasting fullført',
      uploadFailed: 'Opplasting feilet',
      fillRequiredFields: 'Vennligst fyll ut alle påkrevde felt',
      reviewRequired: 'Vennligst skriv en anmeldelse',
      bookThroughProfile: 'Vennligst bestill via hjelperens profilside',
      emailNotVerifiedBooking: 'Vennligst bekreft e-posten din før du bestiller',
      emailNotVerifiedJob: 'Vennligst bekreft e-posten din før du legger ut oppdrag',
    },
    verification: {
      title: 'E-postbekreftelse',
      verifying: 'Bekrefter e-posten din...',
      success: 'E-post bekreftet!',
      successDetail: 'E-postadressen din er bekreftet. Du har nå full tilgang til Vennli.',
      error: 'Bekreftelsen feilet',
      errorDetail: 'Lenken kan ha utløpt eller er ugyldig. Prøv å sende en ny bekreftelseslenke.',
      checkInbox: 'Sjekk innboksen din',
      checkInboxDetail: 'Vi har sendt en bekreftelseslenke til e-postadressen din. Klikk lenken for å bekrefte kontoen.',
      goToDashboard: 'Gå til kontrollpanelet',
      resendButton: 'Send på nytt',
      resending: 'Sender...',
      resendSuccess: 'Ny bekreftelseslenke sendt! Sjekk innboksen din.',
      resendError: 'Kunne ikke sende bekreftelseslenke. Prøv igjen senere.',
      bannerTitle: 'E-posten din er ikke bekreftet ennå',
      bannerSubtitle: 'Bekreft e-posten for å bestille tjenester og legge ut oppdrag.',
    },
    feedback: {
      widgetTab: 'Ris / ros?',
      modalTitle: 'Del dine tanker med oss',
      categoryRos: 'Ros',
      categoryRosDesc: 'Noe du liker eller setter pris på',
      categoryForslag: 'Forslag',
      categoryForslagDesc: 'Idé til forbedring eller ny funksjon',
      categoryFeil: 'Noe som ikke funket',
      categoryFeilDesc: 'Noe gikk galt eller var vanskelig',
      categorySporsmal: 'Spørsmål',
      categorySporsmalDesc: 'Lurer du på noe? Spør oss gjerne',
      messagePlaceholder: 'Fortell oss hva du tenker...',
      messageLabel: 'Din melding',
      emailLabel: 'E-post (så vi kan svare deg)',
      emailPlaceholder: 'din@epost.no',
      submitButton: 'Send inn',
      submitting: 'Sender...',
      successTitle: 'Tusen takk!',
      successMessage: 'Vi setter stor pris på at du deler dette med oss. Tilbakemeldingen din hjelper oss å gjøre Vennli bedre for alle.',
      successClose: 'Lukk',
      errorMessage: 'Noe gikk galt. Vennligst prøv igjen.',
      adminTab: 'Innspill',
      statusNew: 'Ny',
      statusSeen: 'Sett',
      statusInProgress: 'Under behandling',
      statusResolved: 'Løst',
      statusArchived: 'Arkivert',
      priorityLow: 'Lav',
      priorityNormal: 'Normal',
      priorityHigh: 'Høy',
      priorityUrgent: 'Haster',
      filterStatus: 'Status',
      filterCategory: 'Kategori',
      filterSearch: 'Søk i innspill...',
      filterAll: 'Alle',
      detailTitle: 'Innspill-detaljer',
      detailMessage: 'Melding',
      detailCategory: 'Kategori',
      detailStatus: 'Status',
      detailPriority: 'Prioritet',
      detailUser: 'Bruker',
      detailEmail: 'E-post',
      detailRole: 'Rolle',
      detailPage: 'Side',
      detailDate: 'Dato',
      detailJourney: 'Brukerreise',
      detailInternalNotes: 'Interne notater',
      detailInternalNotesPlaceholder: 'Skriv interne notater her...',
      detailSave: 'Lagre endringer',
      detailSaving: 'Lagrer...',
      detailSaved: 'Endringer lagret',
      detailBrowser: 'Nettleser',
      detailViewport: 'Skjermstørrelse',
      detailReferrer: 'Referrer',
      detailLanguage: 'Språk',
      notionSync: 'Notion-sync',
      notionSynced: 'Synkronisert',
      notionFailed: 'Sync feilet',
      noSubmissions: 'Ingen innspill ennå',
      totalSubmissions: 'Totalt',
      anonymous: 'Anonym',
    },
  },
  en: {
    // Navigation
    nav: {
      services: 'Services',
      helpers: 'Helpers',
      groups: 'Groups',
      jobs: 'Requests',
      dashboard: 'Dashboard',
      myBookings: 'My Meetings',
      login: 'Log in',
      logout: 'Log out',
      getStarted: 'Get Started',
      findHelpers: 'Find Helpers',
      helper: 'Helper',
      careSeeker: 'Care Seeker',
    },
    pageTitle: {
      home: 'Vennli | Safe meetings across generations',
      login: 'Vennli – Log in',
      register: 'Vennli – Register',
      verifyEmail: 'Vennli – Verify email',
      forgotPassword: 'Vennli – Forgot password',
      resetPassword: 'Vennli – Reset password',
      helpers: 'Vennli – Helpers',
      helperProfile: 'Vennli – Helper profile',
      groups: 'Vennli – Groups',
      groupDetail: 'Vennli – Group',
      jobs: 'Vennli – Requests',
      jobDetail: 'Vennli – Request',
      createJob: 'Vennli – New request',
      services: 'Vennli – Services',
      serviceDetail: 'Vennli – Service',
      createService: 'Vennli – New listing',
      dashboard: 'Vennli – Dashboard',
      bookings: 'Vennli – My meetings',
      bookingDetail: 'Vennli – Meeting details',
      notifications: 'Vennli – Notifications',
      notificationSettings: 'Vennli – Notification settings',
      availability: 'Vennli – Availability',
      admin: 'Vennli – Admin',
      careSeekerProfile: 'Vennli – Profile',
      economy: 'Vennli – Economy',
      stripeReturn: 'Vennli – Stripe setup',
      contact: 'Vennli – Contact us',
    },
    // Landing page
    landing: {
      headline1: 'Connecting',
      headline2: 'generations',
      subtitle: 'Find someone to help, agree on a price, and meet in a safe and friendly way.',
      dnaLine: 'Vennli is a meeting place, not a marketplace.',
      heroPaymentNote: 'Price agreed in advance. Payment handled safely in Vennli.',
      findHelper: 'Find a helper',
      becomeHelper: 'Become a helper',
      howItWorks: 'How does it work?',
      earlyAccess: 'We\u2019re in early access. Join us and help build Vennli \uD83D\uDC9B',
      safetyFirst: 'Safety first',
      safetyFirstDesc: 'We\u2019re building for trust and dignity',
      generationsTitle: 'Who we\u2019re for',
      generationsHeadline: 'Three generations, one community',
      generationsSubtitle: 'Vennli connects people who want to help, families who need relief, and seniors who want companionship and support.',
      youngTitle: 'Young Adults',
      youngSubtitle: 'First experience & growth',
      youngDesc: 'Students and young adults who want to make a difference, gain experience and grow through helping others.',
      youngFeatures: ['Meaningful experience', 'Flexible', 'Making a difference'],
      familiesTitle: 'Families',
      familiesSubtitle: 'Relief & more time',
      familiesDesc: 'Busy families who need relief \u2014 with childcare, errands, housework, or just some extra hands in everyday life.',
      familiesFeatures: ['Childcare & activities', 'Practical help', 'More family time'],
      eldersTitle: 'Seniors',
      eldersSubtitle: 'Help, company & safety',
      eldersDesc: 'Seniors who want companionship, help with daily tasks, digital guidance, or someone to accompany them to appointments.',
      eldersFeatures: ['Companionship', 'Practical help', 'Digital guidance'],
      retiredTitle: 'Retirees & Mentors',
      retiredSubtitle: 'Share experience & find meaning',
      retiredDesc: 'Share your experience, be seen, and give the younger generation a boost. Contribute what you can \u2014 on your terms.',
      retiredFeatures: ['Share life experience', 'Mentorship', 'Everyday meaning'],
      servicesTitle: 'What we help with',
      servicesHeadline: 'What do you need help with?',
      servicesSubtitle: 'From companionship to tech help \u2013 our helpers show up when you need them.',
      groupsTitle: 'Easier together',
      groupsHeadline: 'Easier to help when you\u2019re not alone',
      groupsSubtitle: 'Helpers can come together in small groups and gatherings \u2014 for safety, community, and more meaning.',
      groupsComingSoon: 'Mentor-led gatherings coming soon',
      groupsPointSafety: 'Safer to show up together',
      groupsPointSocial: 'More social and rewarding',
      groupsPointSupport: 'Share responsibility and build community',
      groupsCtaPrimary: 'Become a helper',
      groupsCtaSecondary: 'How does it work?',
      processTitle: 'Here\u2019s how it works',
      processHeadline: 'How Vennli works',
      step1Title: 'Create a profile',
      step1Desc: 'Sign up as a helper or someone who needs help. Tell us a bit about yourself.',
      step2Title: 'Find someone who fits',
      step2Desc: 'See who\u2019s nearby and find someone you\u2019d like to meet.',
      step3Title: 'Agree on a price',
      step3Desc: 'Agree on a price directly between you \u2014 in advance, so everything is clear.',
      step4Title: 'Meet up',
      step4Desc: 'Set a time and place, meet each other, and pay safely through Vennli.',
      opennessTitle: 'Honest and real',
      opennessHeadline: 'Honest and real \u2014 from the start',
      opennessSubtitle: 'We\u2019re building Vennli step by step. The goal is a warm meeting place that makes Norway a little friendlier.',
      opennessCta: 'Find help',
      ctaBadge: 'Safe \u2022 Local \u2022 Vennli',
      footerText: 'A meeting place between generations.',
      ungTitle: 'Under 18?',
      ungHeadline: 'Vennli Ung',
      ungSubtitle: 'Are you under 18 and want to help out in your local community? Sign up for interest and we\u2019ll let you know when Vennli Ung is ready.',
      ungNameLabel: 'Name',
      ungNamePlaceholder: 'Your full name',
      ungBirthDateLabel: 'Date of birth',
      ungPostalCodeLabel: 'Postal code',
      ungPostalCodePlaceholder: '0000',
      ungEmailLabel: 'Email',
      ungEmailPlaceholder: 'your@email.com',
      ungSubmit: 'Sign up for interest',
      ungSubmitting: 'Submitting...',
      ungSuccess: 'Thank you! We\u2019ll let you know when Vennli Ung is ready.',
      ungError: 'Something went wrong. Please try again.',
      ungAlreadyRegistered: 'This email address is already registered.',
      ungBadge: 'Coming soon',
      paymentStripTitle: 'How payment works on Vennli',
      paymentStep1Title: 'Find someone who fits',
      paymentStep1Desc: 'Browse helpers nearby and reach out to whoever feels right for you.',
      paymentStep2Title: 'Agree on a price',
      paymentStep2Desc: 'You agree on a price directly with each other \u2014 before you meet.',
      paymentStep3Title: 'Pay safely in Vennli',
      paymentStep3Desc: 'Payment is handled through Vennli. Simple and safe for both parties.',
      faqTitle: 'Common questions',
      faqQ1: 'Does Vennli cost money?',
      faqA1: 'Yes, most help on Vennli is paid. You agree on a price between yourselves \u2014 there\u2019s no fixed price list. Signing up is free.',
      faqQ2: 'How is the price agreed?',
      faqA2: 'Each helper can set their own price, or you agree on what works for both. Price is always settled in advance \u2014 before you meet.',
      faqQ3: 'How does payment work?',
      faqA3: 'Payment is handled safely through Vennli via Stripe. Money is managed in the platform, keeping things simple and safe for everyone.',
    },
    stripeWizard: {
      step1Title: 'How you get paid',
      step1Bullets: [
        'We use Stripe for safe payouts',
        'A personal bank account is fine – no company needed',
        'You don\'t need a business registration number',
        'Takes just 2–3 minutes to set up',
      ],
      step1Button: 'Continue',
      step2Title: 'Tax & frikort (quick overview)',
      step2Bullets: [
        'Income via Vennli is taxable',
        'You can use your frikort allowance (100,000 kr in 2026)',
        'We show income and frikort overview in the app',
        'You are responsible for reporting to the tax authorities',
      ],
      step2Disclaimer: 'Vennli does not provide tax advice. Contact Skatteetaten if you have questions.',
      step2Button: 'Ok – connect to Stripe',
      step3Title: 'You\'ll be redirected to Stripe',
      step3Desc: 'Stripe collects ID verification and bank information. You can abort at any time and come back later.',
      step3Button: 'Open Stripe',
      stepIndicator: 'Step {current} of {total}',
    },
    economy: {
      title: 'Economy',
      subtitle: 'Overview of income, payouts and tax – simple and safe.',
      stripeReady: 'Payouts are ready',
      stripeReadyDesc: 'Stripe is set up and ready to use.',
      stripePending: 'Setup incomplete',
      stripePendingDesc: 'Complete Stripe setup to receive payouts.',
      stripeSetup: 'Complete Stripe setup',
      stripeNotStarted: 'Connect payouts',
      incomeTitle: 'Income this year',
      helperAmount: 'Paid to you',
      platformContribution: 'Contribution to Vennli',
      totalAmount: 'Total paid by clients',
      meetingCount: 'Paid meetings',
      frikortTitle: 'Tax & frikort',
      frikortLabel: 'Your frikort limit',
      frikortProgress: '{amount} kr of {limit} kr used',
      frikortWarning: 'You are approaching your frikort limit. Consider checking your tax card.',
      frikortDisclaimer: 'This is not legal advice – always check Skatteetaten when needed.',
      frikortSave: 'Save',
      frikortSaved: 'Saved!',
      transactionsTitle: 'Transactions',
      date: 'Date',
      service: 'Service',
      seeker: 'Client',
      amount: 'To you',
      contribution: 'Contribution',
      status: 'Status',
      downloadCsv: 'Download income report (CSV)',
      backToDashboard: 'Back to dashboard',
      noTransactions: 'No paid meetings yet.',
      kr: 'kr',
      paid: 'Paid',
      seeEconomy: 'See economy',
    },
    contact: {
      backToHome: 'Back to home',
      title: 'We\u2019re here for you',
      subtitle: 'Have questions, feedback, or just want to say hello? We\u2019d love to hear from you.',
      emailLabel: 'Send us an email',
      emailHint: 'We usually reply within one business day.',
      phoneLabel: 'Give us a call',
      phoneHint: 'Weekdays between 09:00 and 17:00.',
      warmNote: 'Vennli is built with warmth. We appreciate you reaching out.',
      footerLink: 'Contact us',
    },
    // Services/Categories
    services: {
      selskapSamvaer: 'Social & Companionship',
      selskapSamvaerDesc: 'Social visits, conversation and friendly company',
      aerendFolge: 'Errands & Escort',
      aerendFolgeDesc: 'Shopping, appointments and accompaniment',
      tekniskHjelp: 'Tech Help',
      tekniskHjelpDesc: 'Help with phone, PC and digital tools',
      hjemmehjelp: 'Home Help',
      hjemmehjelpDesc: 'Light cleaning, tidying and household tasks',
      hageUte: 'Garden & Outdoors',
      hageUteDesc: 'Gardening, lawn mowing and outdoor areas',
      dyreomsorg: 'Pet Care',
      dyreomsorgDesc: 'Pet sitting, dog walking and animal care',
      barnepassLeksehjelp: 'Childcare & Tutoring',
      barnepassLeksehjelpDesc: 'Childcare, activities and homework help',
      laeringDeling: 'Learning & Sharing',
      laeringDelingDesc: 'Share knowledge, learn something new together',
      other: 'Other',
      otherDesc: 'Have something else to offer? Send us a suggestion',
      companionship: 'Social & Companionship',
      companionshipDesc: 'Social visits, conversation and friendly company',
      errands: 'Errands & Escort',
      errandsDesc: 'Shopping, appointments and accompaniment',
      techHelp: 'Tech Help',
      techHelpDesc: 'Help with phone, PC and digital tools',
      household: 'Home Help',
      householdDesc: 'Light cleaning, tidying and household tasks',
    },
    // Auth
    auth: {
      welcomeBack: 'Welcome back',
      enterCredentials: 'Enter your credentials to access your account',
      email: 'Email',
      password: 'Password',
      loggingIn: 'Signing in...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      createAccount: 'Create Account',
      joinCommunity: 'Join our community of helpers and care seekers',
      iWantTo: 'I want to...',
      findHelp: 'Find Help',
      offerHelp: 'Offer Help',
      fullName: 'Full Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone Number',
      postalCode: 'Postal Code',
      creatingAccount: 'Creating Account...',
      hasAccount: 'Already have an account?',
      signIn: 'Sign in',
      backToHome: 'Back to Home',
      verifyEmailNote: 'Email must be verified before your account is active',
      emailAlreadyRegistered: 'This email is already registered. Try logging in instead.',
      passwordTooShort: 'Password must be at least 8 characters.',
      registrationFailed: 'Something went wrong. Please try again.',
      forgotPassword: 'Forgot password?',
      forgotPasswordTitle: 'Reset password',
      forgotPasswordDesc: 'Enter your email address and we\u2019ll send you a link to choose a new password.',
      sendResetLink: 'Send reset link',
      sending: 'Sending...',
      resetLinkSent: 'If an account with this email exists, we\u2019ve sent a reset link.',
      backToLogin: 'Back to login',
      resetPasswordTitle: 'Choose a new password',
      resetPasswordDesc: 'Enter your new password below.',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
      resetPassword: 'Save new password',
      resetting: 'Saving...',
      passwordResetSuccess: 'Your password has been reset! You can now log in.',
      passwordsDoNotMatch: 'Passwords do not match.',
      invalidResetLink: 'Invalid or expired reset link.',
    },
    // Helpers page
    helpers: {
      title: 'Find Your Helper',
      subtitle: 'Discover trusted helpers in your area',
      searchPlaceholder: 'Search helpers...',
      filterByService: 'Service Type',
      filterLocation: 'Location',
      filterRate: 'Max Rate',
      locationPlaceholder: 'Enter city or zip...',
      allServices: 'All Services',
      newHelper: 'New',
      noHelpers: 'No helpers found',
      loading: 'Loading helpers...',
      viewProfile: 'View Profile',
      perHour: 'per hour',
      reviews: 'reviews',
      verified: 'Verified',
      available: 'Available',
      groupAvailable: 'Available as a group',
      groupSafety: 'Safer',
      groupSocial: 'Social',
      viewGroup: 'View group',
      groupCtaTitle: 'Want to work together?',
      groupCtaSubtitle: 'Create or join a group for safer and more social assignments.',
      groupCtaButton: 'Create or join',
      groupCtaView: 'View my group',
      backToHelpers: 'Back to Helpers',
      notFound: 'Helper not found',
    },
    // Helper Profile
    helperProfile: {
      about: 'About',
      servicesOffered: 'Services Offered',
      reviews: 'Reviews',
      bookNow: 'Ask for help',
      contact: 'Contact',
      memberSince: 'Member since',
      noReviews: 'No reviews yet',
      hourlyRate: 'Hourly Rate',
      serviceListings: 'Service Listings',
      activeListings: 'Active Listings',
    },
    // Groups page
    groups: {
      title: 'Helper Groups',
      subtitle: 'Find groups of helpers working together',
      bannerTitle: 'Offer Services Together',
      bannerSubtitle: 'Join or create a group to offer services together. It is safer, more social, and a great way to meet new people.',
      bannerSafer: 'Safer',
      bannerSocial: 'Social',
      bannerExperience: 'Experience',
      filterServiceLabel: 'Service Type',
      filterRateLabel: 'Max Rate',
      allServices: 'All Services',
      anyRate: 'Any Rate',
      noGroupsTitle: 'No groups yet',
      noGroupsCta: 'Be the first to create a helper group!',
      myGroup: 'My Group',
      yourGroupBadge: 'Your Group',
      joining: 'Sending...',
      join: 'Get to know',
      requestSent: 'Request sent',
      alreadyMember: 'You are a member',
      searchPlaceholder: 'Search groups...',
      createGroup: 'Create a Group',
      noGroups: 'No groups found',
      loading: 'Loading groups...',
      viewGroup: 'View Group',
      members: 'members',
      member: 'Member',
      groupRate: 'Group Rate',
      joinForces: 'Join forces with other helpers for bigger jobs',
      joinModeRequest: 'With approval',
      joinModeInviteOnly: 'Invite only',
    },
    groupDetail: {
      groupDetails: 'Group Details',
      backToGroups: 'Back to Groups',
      groupMembers: 'Group Members',
      leader: 'Leader',
      joined: 'Joined',
      joinGroup: 'Join Group',
      leaveGroup: 'Leave Group',
      bookGroup: 'Book Group',
      specialties: 'Specialties',
      deleteGroup: 'Delete Group',
      editGroup: 'Edit Group',
      deleteTitle: 'Delete this group?',
      deleteDescription: 'This action cannot be undone. All members will be removed from the group.',
      coverPhoto: 'Cover Photo',
      uploadCoverPhoto: 'Upload cover photo',
      changeCoverPhoto: 'Change cover photo',
      removeCoverPhoto: 'Remove cover photo',
      noReviews: 'No reviews yet',
      bookingSubtitle: 'Schedule a session with this helper group ({count} members)',
      rateLabel: 'Rate',
      groupHelpersLabel: 'Group of {count} helpers',
      continuePayment: 'Continue to Payment',
      creatingBooking: 'Creating Booking...',
      membershipTitle: 'Membership',
      membershipRequest: 'Group leader approves new members',
      membershipInviteOnly: 'By invitation from group leader only',
      membershipSafe: 'We want groups to feel safe and real. Start by saying hello',
      requestToJoin: 'Send request',
      contactFirst: 'Reach out first',
      requestPlaceholder: 'Say hello — why do you want to join?',
      sendRequest: 'Send request to join',
      sending: 'Sending...',
      requestPending: 'Request sent',
      requestPendingNote: 'The group leader is reviewing your request',
      requestApproved: 'Request approved!',
      requestRejected: 'Request was not approved',
      leaderReply: 'Reply from group leader',
      pendingRequests: 'Requests',
      noPendingRequests: 'No pending requests',
      approve: 'Approve',
      reject: 'Decline',
      replyToRequest: 'Reply',
      replyPlaceholder: 'Write a short message...',
      inviteByEmail: 'Invite by email',
      inviteEmailPlaceholder: 'name@example.com',
      inviteMessagePlaceholder: 'Personal greeting (optional)',
      sendInvite: 'Send invitation',
      sendingInvite: 'Sending...',
      inviteSent: 'Invitation sent!',
      pendingInvites: 'Invitations',
      noPendingInvites: 'No pending invitations',
      inviteStatus: 'Status',
      invitePending: 'Pending',
      inviteAccepted: 'Accepted',
      inviteExpired: 'Expired',
      joinModeLabel: 'Access type',
      joinModeRequest: 'With approval (recommended)',
      joinModeInviteOnly: 'Invite only (safest)',
      leaderControls: 'Group leader',
      acceptInviteTitle: 'Accept invitation',
      acceptInviteDesc: 'You have been invited to join this group.',
      acceptInvite: 'Accept invitation',
      accepting: 'Accepting...',
    },
    groupCreate: {
      title: 'Create a Group',
      subtitle: 'Start a helper group and invite others to join',
      nameLabel: 'Group Name',
      namePlaceholder: 'e.g., Campus Helpers, Neighborhood Squad',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Tell care seekers about your group...',
      servicesLabel: 'Services Offered',
      rateLabel: 'Group Hourly Rate',
      rateHelp: 'Groups often charge lower rates, making services more affordable',
      createButton: 'Create Group',
      creating: 'Creating...',
      joinModeLabel: 'Who can join?',
      joinModeRequest: 'With approval (recommended)',
      joinModeInviteOnly: 'Invite only (safest)',
    },
    // Jobs page
    jobs: {
      title: 'Job Board',
      subtitle: 'Browse available jobs from care seekers',
      helperSubtitle: 'Find jobs posted by care seekers who need help',
      careSeekerSubtitle: 'Post a job and get help from the community',
      searchPlaceholder: 'Search jobs...',
      postJob: 'Post a Job',
      bannerTitle: 'Browse Available Jobs',
      bannerSubtitle: 'Care seekers post jobs they need help with. Apply to jobs that match your skills and availability.',
      filterServiceLabel: 'Service Type',
      filterUrgencyLabel: 'Urgency',
      allServices: 'All Services',
      anyUrgency: 'Any urgency',
      noJobsTitle: 'No jobs posted yet',
      noJobsCareSeeker: 'Be the first to post a job!',
      noJobsHelper: 'Check back later for new opportunities',
      noJobs: 'No jobs found',
      loading: 'Loading jobs...',
      viewDetails: 'View Details',
      budget: 'Budget',
      urgency: 'Urgency',
      urgent: 'Urgent',
      thisWeek: 'This Week',
      flexible: 'Flexible',
      applications: 'applications',
      postedBy: 'Posted by',
      open: 'Open',
      inProgress: 'In Progress',
      completed: 'Completed',
    },
    // Job Detail
    jobDetail: {
      jobDetails: 'Job Details',
      backToJobs: 'Back to Jobs',
      deleteTitle: 'Delete this job?',
      deleteDescription: 'This will permanently delete the job posting and all applications.',
      deleteConfirm: 'Delete',
      descriptionTitle: 'Job Description',
      budgetTitle: 'Budget',
      mediaTitle: 'Photos & Videos',
      addMedia: 'Add',
      mediaEmpty: 'No media uploaded yet',
      applicationsEmpty: 'No applications yet',
      applicantGroup: 'Group',
      applicantHelper: 'Individual Helper',
      applyCardTitle: 'Interested in this job?',
      applyCardSubtitle: 'Apply now and let the poster know you can help!',
      applyNow: 'Apply Now',
      yourApplication: 'Your Application',
      coverLetter: 'Cover Letter',
      proposedRate: 'Proposed Rate',
      submitApplication: 'Submit Application',
      applyDialogTitle: 'Apply to Job',
      applyDialogSubtitle: "Tell the poster why you're a good fit",
      applyMessageLabel: 'Your Message',
      applyMessagePlaceholder: 'Introduce yourself and explain why you would be great for this job...',
      applyRateLabel: 'Proposed Rate (Optional)',
      applyRatePlaceholder: 'Your rate',
      applySubmitting: 'Submitting...',
      alreadyApplied: 'You have already applied',
      applicationsTitle: 'Applications',
      accept: 'Accept',
      reject: 'Reject',
      accepted: 'Accepted',
      rejected: 'Rejected',
      pending: 'Pending',
      postedByLabel: 'Posted by',
      postedRole: 'Care Seeker',
    },
    // Create Job
    createJob: {
      title: 'Post a New Job',
      subtitle: 'Describe the job you need help with',
      jobTitle: 'Job Title',
      jobTitlePlaceholder: 'E.g. Help with gardening',
      description: 'Description',
      descriptionPlaceholder: 'Describe the job in detail...',
      descriptionHelp: 'The more details you provide, the better matches you will get',
      serviceType: 'Service Type',
      selectService: 'Select a service',
      budgetRange: 'Budget Range',
      minimum: 'Minimum',
      maximum: 'Maximum',
      location: 'Location',
      locationPlaceholder: 'E.g. Oslo, Norway',
      urgencyLevel: 'Urgency Level',
      urgencyPrompt: 'How soon do you need this done?',
      addMedia: 'Add Photos or Videos',
      mediaHelp: 'Add images or videos to help explain the job',
      mediaUploadCta: 'Click to upload images or videos',
      mediaSupported: 'Supports JPEG, PNG, GIF, WebP, MP4, MOV, WebM. Max 50MB per file.',
      postJob: 'Post Job',
      posting: 'Posting...',
    },
    // Services Listings page
    serviceListings: {
      title: 'Service Listings',
      subtitle: 'Browse services offered by our helpers',
      searchPlaceholder: 'Search services...',
      listService: 'List Your Service',
      noServices: 'No services found',
      loading: 'Loading services...',
      viewService: 'View Service',
      remoteAvailable: 'Remote Available',
      groupService: 'Group Service',
      filterByCategory: 'Filter by category',
      allCategories: 'All Categories',
      priceRange: 'Price Range',
      remoteOnly: 'Remote only',
    },
    // Service Listing Detail
    serviceDetail: {
      serviceDetails: 'Service Details',
      offeredBy: 'Offered by',
      bookService: 'Schedule a Meeting',
      editService: 'Edit Service',
      deleteService: 'Delete Service',
      deleteConfirmTitle: 'Delete this service?',
      activeLabel: 'Active (visible to others)',
      price: 'Price',
      perHour: 'per hour',
      fixedPrice: 'fixed price',
      startingAt: 'starting at',
      duration: 'Duration',
      category: 'Category',
      tags: 'Tags',
      remote: 'Remote',
      yes: 'Yes',
      no: 'No',
      backToServices: 'Back to Services',
      addMedia: 'Add Photos/Videos',
      aboutService: 'About this service',
      groupService: 'Group Service',
      inactive: 'Inactive',
      saveChanges: 'Save Changes',
      loginToBook: 'Log in to Book',
      viewGroupProfile: 'View Group Profile',
      bookings: 'Bookings',
      listed: 'Listed',
      rating: 'rating',
    },
    // Create Service Listing
    servicesPage: {
      title: 'Services',
      subtitle: 'Discover unique services offered by our helpers',
      searchPlaceholder: 'Search services by keyword...',
      search: 'Search',
      category: 'Category',
      allCategories: 'All Categories',
      maxPrice: 'Max Price',
      anyPrice: 'Any Price',
      upTo: 'Up to',
      remoteOnly: 'Remote Only',
      groupServices: 'Group Services',
      listService: 'List Your Service',
      group: 'Group',
    },
    createService: {
      title: 'Tell us how you can help',
      subtitle: 'Describe what you can offer, and we\'ll connect you with someone who needs you',
      serviceTitle: 'Title',
      serviceTitlePlaceholder: 'E.g. Friendly company over a cup of coffee',
      description: 'Description',
      descriptionPlaceholder: 'Tell us a bit about what you can help with. What do you enjoy doing? How can you brighten someone\'s day?',
      category: 'Category',
      selectCategory: 'Select a category',
      categoryHelperText: 'Pick what fits best. Something else? Send us a suggestion 💛',
      customCategoryPlaceholder: 'Briefly describe what you can help with (max 120 characters)',
      pendingNotice: 'Thank you for your suggestion! We\'ll review it and make it visible as soon as possible.',
      pricingType: 'Pricing Type',
      hourly: 'Hourly',
      fixed: 'Fixed',
      startingAt: 'Starting at',
      price: 'Price',
      durationEstimate: 'Duration Estimate',
      durationPlaceholder: 'E.g. 1-2 hours, half day, varies',
      location: 'Location',
      locationPlaceholder: 'City, area, or \'Your location\'',
      remoteService: 'Available remotely',
      tags: 'Tags',
      tagsPlaceholder: 'Type a tag and press Enter',
      tagsHelp: 'Add up to 5 tags to help people find your listing',
      addMedia: 'Add photos or videos',
      mediaHelp: 'Show examples of your work or yourself in action',
      uploadMedia: 'Upload images or videos',
      uploading: 'Uploading...',
      uploadHelp: 'Supports JPEG, PNG, GIF, WebP, MP4, MOV, WebM. Max 50MB per file.',
      createListing: 'Create Listing',
      listMyService: 'List My Service',
      creating: 'Creating...',
      backToServices: 'Back to Listings',
      groupNotice: 'This listing will appear under your group:',
      groupMember: 'You are a member of',
      groupServiceToggle: 'Group listing',
      listedAsGroup: 'This listing will appear under your group',
      listedAsIndividual: 'This listing will appear as your own, not the group\'s',
      optional: 'Optional',
    },
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcomeBack: 'Good to see you',
      helperSubtitle: 'Here\u2019s an overview of your meetings \u2014 and how you can help.',
      seekerSubtitle: 'Here\u2019s an overview of your meetings and the helpers you\u2019ve found.',
      yourStats: 'Your Stats',
      totalBookings: 'Meetings agreed',
      pendingBookings: 'Waiting for reply',
      completedBookings: 'Completed',
      totalEarnings: 'Earned so far',
      yourProfile: 'Your Profile',
      profileDna: 'Vennli is about dignity \u2014 helping, and being seen.',
      editProfile: 'Edit Profile',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      bio: 'Bio',
      bioPlaceholder: 'Tell us about yourself...',
      location: 'Location',
      locationPlaceholder: 'E.g. Oslo, Norway',
      hourlyRate: 'Hourly Rate',
      phone: 'Phone',
      phonePlaceholder: '+47 xxx xx xxx',
      available: 'Available for meetings',
      servicesYouOffer: 'What you can help with',
      recentBookings: 'Recent meetings',
      viewAll: 'View All',
      noBookings: 'No meetings yet \u2014 but they\u2019re coming \uD83D\uDC9B',
      noBookingsTip: 'Tip: Start with \u201cCompanionship\u201d or \u201cErrands\u201d to get going.',
      yourGroup: 'Your community',
      viewMyGroup: 'View community',
      groupHint: 'Groups make it safer and more social to help.',
      groupComingSoon: 'Mentor-led gatherings coming soon \u2728',
      notInGroup: 'You\u2019re not part of a community yet',
      browseGroups: 'Explore communities',
      yourListings: 'Your listings',
      createListing: 'Share how I can help',
      noListings: 'You have no listings yet',
      quickActions: 'Get started',
      browseHelpers: 'Browse Helpers',
      viewBookings: 'View my meetings',
      allSet: 'Ready for your first meeting \u2728',
      helperEmptyHint: 'Share how you can help \u2014 or explore people nearby who need a hand.',
      seekerEmptyHint: 'Explore helpers nearby, or post a request to find the right match.',
      browseJobs: 'Browse requests',
      currency: 'kr',
      perHour: '/hr',
    },
    // Bookings page
    bookings: {
      title: 'My Bookings',
      subtitle: 'Manage your bookings',
      helperSubtitle: 'Manage your service requests',
      seekerSubtitle: 'Track your booked services',
      allBookings: 'All Bookings',
      upcoming: 'Upcoming',
      past: 'Past',
      noBookings: 'No bookings found',
      loading: 'Loading bookings...',
      viewBooking: 'View Booking',
      with: 'with',
      group: 'Group',
      openRequest: 'Open request',
      flexibleRequest: 'Flexible request',
    },
    // Booking Detail
    bookingDetail: {
      bookingDetails: 'Booking Details',
      backToBookings: 'Back to Bookings',
      service: 'Service',
      dateTime: 'Date & Time',
      duration: 'Duration',
      totalAmount: 'Total Amount',
      paymentStatus: 'Payment Status',
      bookingStatus: 'Booking Status',
      payNow: 'Pay Now',
      confirmBooking: 'Confirm Booking',
      cancelBooking: 'Cancel Booking',
      completeBooking: 'Complete Booking',
      leaveReview: 'Leave a Review',
      leaveReviewHelper: 'Review helper',
      leaveReviewSeeker: 'Review care seeker',
      notes: 'Notes',
      helper: 'Helper',
      careSeeker: 'Care Seeker',
      groupMembers: 'Group Members',
      groupBooking: 'Group Booking',
      groupHelpers: 'Helpers in this group',
      openRequest: 'Open request',
      openRequestNote: 'Time to be arranged in chat',
      rating: 'Rating',
      comment: 'Comment',
      submitReview: 'Submit Review',
      reviewTitle: 'Leave a Review',
      reviewTitleHelper: 'Review helper',
      reviewTitleSeeker: 'Review care seeker',
      reviewFor: 'Share your experience with {name}.',
      reviewHiddenNote: 'Your review becomes visible once both parties have reviewed.',
      reviewPlaceholder: 'Tell others about your experience...',
      submittingReview: 'Submitting...',
      viewCareSeekerProfile: 'View care seeker profile',
      meetingLabel: 'Meeting',
      platformContribution: 'Vennli contribution',
      totalLabel: 'Total',
      goToPayment: 'Go to payment',
      paymentRequired: 'Payment must be completed before leaving a review',
      waitingForApproval: 'Waiting for helper approval',
      approveBooking: 'Approve',
      declineBooking: 'Decline',
      approveConfirmTitle: 'Approve booking?',
      approveConfirmDescription: 'Once approved, the care seeker can proceed with payment.',
      declineConfirmTitle: 'Decline booking?',
      declineConfirmDescription: 'Are you sure you want to decline this booking?',
      markCompleted: 'Mark as completed',
      bookingCompleted: 'Booking completed',
      contributionTooltipTitle: 'Contribution to Vennli',
      contributionTooltipBody: 'This is paid by the person booking. The contribution helps us keep Vennli alive – a meeting place that makes it easier to help, and be seen.',
      thankYouContribution: 'Thank you for contributing to a warmer local community.',
      safePaymentTitle: 'How safe payment works',
      safePaymentStep1: 'The payment confirms that the funds are available',
      safePaymentStep2: 'Once the task is completed, the payout is prepared',
      safePaymentStep3: 'You can always contact us if something didn\'t go as planned',
    },
    stripeConnect: {
      payoutsTitle: 'Payouts',
      connectButton: 'Connect payouts (Stripe)',
      resumeButton: 'Complete setup',
      readyMessage: 'Payouts are ready',
      readyDescription: 'You are ready to receive payments for your services via Vennli.',
      connectDescription: 'Connect to Stripe to receive payouts safely and easily.',
      pendingDescription: 'Your setup is almost ready. Complete the last step with Stripe.',
      onboardingReturnTitle: 'Stripe setup',
      onboardingReturnComplete: 'Setup complete! You are now ready to receive payouts.',
      onboardingReturnPending: 'Setup is almost done. You may need to complete a few more steps.',
      onboardingRefreshTitle: 'Try again',
      onboardingRefreshDescription: 'The link has expired. Click below to get a new link.',
      getNewLink: 'Get new link',
      backToDashboard: 'Back to dashboard',
      loading: 'Checking status...',
    },
    careSeekerProfile: {
      title: 'Care Seeker Profile',
      subtitle: 'Feedback from helpers',
      reviewsTitle: 'Reviews',
      noReviews: 'No reviews yet',
      memberSince: 'Member since',
    },
    // Booking Form
    bookingForm: {
      bookHelper: 'Book Helper',
      bookGroup: 'Book Group',
      selectService: 'Select Service',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      duration: 'Duration (hours)',
      notes: 'Additional Notes',
      notesPlaceholder: 'Any special requests or information...',
      totalCost: 'Total Cost',
      confirmBooking: 'Confirm Booking',
      booking: 'Booking...',
      openRequestLabel: 'Open request',
      openRequestHint: 'Leave date/time open and coordinate in chat',
      noAvailableTimes: 'No available times',
      availabilityHint: 'Select a date to see available times',
    },
    messaging: {
      title: 'Messages',
      subtitle: 'Coordinate details for this booking',
      empty: 'No messages yet',
      inputPlaceholder: 'Write a message...',
      send: 'Send',
      sending: 'Sending...',
      attach: 'Attach',
      attachments: 'Attachments',
      removeAttachment: 'Remove attachment',
    },
    notifications: {
      title: 'Notifications',
      subtitle: 'Stay on top of messages and status updates',
      empty: 'No notifications yet',
      markAllRead: 'Mark all as read',
      messageTitle: 'New message',
      bookingTitle: 'Booking updated',
      paymentTitle: 'Payment received',
      messageBody: '{sender} sent a new message',
      bookingBody: 'Booking status is now {status}',
      paymentBody: 'Payment received: {amount}',
      viewBooking: 'View booking',
    },
    notificationSettings: {
      title: 'Notification Settings',
      subtitle: 'Choose how you want to be notified',
      inAppLabel: 'In-app notifications',
      inAppHint: 'Show notifications inside Vennli',
      emailLabel: 'Email notifications',
      emailHint: 'Emails will send once a provider is connected',
      save: 'Save settings',
      saving: 'Saving...',
    },
    availability: {
      title: 'Availability',
      subtitle: 'Set your weekly schedule and add exceptions for specific days',
      onlyHelpers: 'Only helpers can manage availability.',
      weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      weekdaysFull: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      slots: 'slots',
      dayHint: 'Pick the hours you are available on this day.',
      addSlots: 'Add time blocks',
      start: 'Start',
      end: 'End',
      addButton: 'Add hours',
      availableSlots: 'Available hours',
      clearDay: 'Clear day',
      noSlots: 'No hours added yet',
      invalidRange: 'Select a valid time range',
      defaultSchedule: 'Weekly Schedule',
      defaultScheduleHint: 'Set the hours you are typically available each week. These apply automatically to all future weeks.',
      saveDefaults: 'Save schedule',
      savingDefaults: 'Saving...',
      defaultsSaved: 'Schedule saved',
      available: 'Available',
      notSet: 'Not set',
      exceptions: 'Exceptions',
      exceptionsHint: 'Click a day to override the default schedule for that date.',
      isDefault: 'Default',
      isOverride: 'Custom',
      isBlocked: 'Blocked',
      resetToDefault: 'Reset to default',
      blockDay: 'Block this day',
      overrideDay: 'Custom hours',
    },
    admin: {
      title: 'Admin Panel',
      subtitle: 'Manage the platform',
      refresh: 'Refresh',
      noAccess: 'You do not have access to the admin panel.',
      delete: 'Delete',
      view: 'View',
      deleteConfirm: 'Are you sure you want to delete this?',
      tabs: {
        users: 'Users',
        bookings: 'Bookings',
        jobs: 'Jobs',
        groups: 'Groups',
        listings: 'Services',
        payments: 'Payments',
      },
      kpi: {
        totalUsers: 'Total users',
        helpers: 'Helpers',
        seekers: 'Care seekers',
        bookings: 'Bookings',
        jobs: 'Jobs',
        groups: 'Groups',
        listings: 'Services',
        payments: 'Payments',
      },
      userName: 'Name',
      userEmail: 'Email',
      userRole: 'Role',
      createdAt: 'Created',
      roles: {
        helper: 'Helper',
        seeker: 'Care seeker',
        admin: 'Admin',
      },
      bookingId: 'ID',
      bookingService: 'Service',
      bookingSchedule: 'Schedule',
      bookingStatus: 'Status',
      bookingPayment: 'Payment',
      jobTitle: 'Job',
      jobBudget: 'Budget',
      groupName: 'Group',
      groupMembers: 'Members',
      listingTitle: 'Service',
      listingPrice: 'Price',
      paymentId: 'Payment',
      paymentBooking: 'Booking',
      paymentAmount: 'Amount',
      paymentStatus: 'Status',
      createdBy: 'Created by',
    },
    // Common
    common: {
      perHour: 'per hour',
      reviews: 'reviews',
      new: 'New',
      status: 'Status',
      availableLabel: 'Available',
      unavailableLabel: 'Unavailable',
      date: 'Date',
      time: 'Time',
      duration: 'Duration',
      notes: 'Notes',
      optional: 'Optional',
      notesPlaceholder: 'Any special requests or details...',
      someone: 'Someone',
      markAsRead: 'Mark as read',
      viewProfile: 'View Profile',
      viewDetails: 'View Details',
      bookNow: 'Ask for help',
      loading: 'Loading...',
      noResults: 'No results found',
      search: 'Search',
      filter: 'Filter',
      clear: 'Clear',
      all: 'All',
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      submit: 'Submit',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      close: 'Close',
      confirmed: 'confirmed',
      pending: 'pending',
      completed: 'completed',
      cancelled: 'cancelled',
      open: 'open',
      approved: 'approved',
      declined: 'declined',
      inProgress: 'in progress',
      paid: 'paid',
      unpaid: 'unpaid',
      hours: 'hours',
      member: 'Member',
      members: 'members',
      from: 'from',
      to: 'to',
      upTo: 'Up to',
      or: 'or',
      and: 'and',
      yes: 'Yes',
      no: 'No',
      group: 'Group',
      individualHelper: 'Individual Helper',
      posted: 'Posted',
      media: 'Media',
      processing: 'Processing...',
      uploading: 'Uploading...',
      saving: 'Saving...',
      kr: 'kr',
      nok: 'NOK',
    },
    categories: {
      selskapSamvaer: 'Social & Companionship',
      aerendFolge: 'Errands & Escort',
      tekniskHjelp: 'Tech Help',
      hjemmehjelp: 'Home Help',
      hageUte: 'Garden & Outdoors',
      dyreomsorg: 'Pet Care',
      barnepassLeksehjelp: 'Childcare & Tutoring',
      laeringDeling: 'Learning & Sharing',
      other: 'Other (Send suggestion)',
      companionship: 'Social & Companionship',
      errands: 'Errands & Escort',
      techHelp: 'Tech Help',
      household: 'Home Help',
    },
    // Errors & Messages
    messages: {
      success: 'Success!',
      error: 'Something went wrong',
      notFound: 'We could not find that information.',
      saved: 'Saved',
      deleted: 'Deleted',
      updated: 'Updated',
      created: 'Created',
      bookingConfirmed: 'Booking confirmed',
      paymentSuccess: 'Payment successful',
      paymentExpired: 'Payment session expired',
      paymentTimeout: 'Payment status timed out. Please refresh.',
      applicationSent: 'Application sent',
      reviewSubmitted: 'Review submitted',
      profileUpdated: 'Profile updated',
      listingCreated: 'Listing created',
      jobPosted: 'Job posted',
      groupCreated: 'Group created',
      joinedGroup: 'Successfully joined the group',
      loginRequired: 'Please log in',
      onlyHelpers: 'Only helpers can do this action',
      alreadyInGroup: 'You are already in a group',
      groupNameRequired: 'Please enter a group name',
      serviceRequired: 'Please select at least one service',
      messageRequired: 'Please write a message',
      jobTitleRequired: 'Please enter a job title',
      jobDescriptionRequired: 'Please describe the job',
      onlyCareSeeker: 'Only care seekers can post jobs',
      onlyCareSeekerBooking: 'Only care seekers can book groups',
      uploadSuccess: 'Upload completed',
      uploadFailed: 'Upload failed',
      fillRequiredFields: 'Please fill in all required fields',
      reviewRequired: 'Please write a review',
      bookThroughProfile: 'Please book through the helper profile page',
      emailNotVerifiedBooking: 'Please verify your email before booking',
      emailNotVerifiedJob: 'Please verify your email before posting jobs',
    },
    verification: {
      title: 'Email Verification',
      verifying: 'Verifying your email...',
      success: 'Email verified!',
      successDetail: 'Your email address has been verified. You now have full access to Vennli.',
      error: 'Verification failed',
      errorDetail: 'The link may have expired or is invalid. Try sending a new verification link.',
      checkInbox: 'Check your inbox',
      checkInboxDetail: 'We sent a verification link to your email address. Click the link to verify your account.',
      goToDashboard: 'Go to Dashboard',
      resendButton: 'Resend',
      resending: 'Sending...',
      resendSuccess: 'New verification link sent! Check your inbox.',
      resendError: 'Could not send verification link. Please try again later.',
      bannerTitle: 'Your email is not verified yet',
      bannerSubtitle: 'Verify your email to book services and post jobs.',
    },
    feedback: {
      widgetTab: 'Feedback?',
      modalTitle: 'Share your thoughts with us',
      categoryRos: 'Praise',
      categoryRosDesc: 'Something you like or appreciate',
      categoryForslag: 'Suggestion',
      categoryForslagDesc: 'An idea for improvement or a new feature',
      categoryFeil: 'Something didn\u2019t work',
      categoryFeilDesc: 'Something went wrong or was difficult',
      categorySporsmal: 'Question',
      categorySporsmalDesc: 'Wondering about something? Just ask',
      messagePlaceholder: 'Tell us what you think...',
      messageLabel: 'Your message',
      emailLabel: 'Email (so we can get back to you)',
      emailPlaceholder: 'your@email.com',
      submitButton: 'Submit',
      submitting: 'Submitting...',
      successTitle: 'Thank you!',
      successMessage: 'We truly appreciate you sharing this with us. Your feedback helps us make Vennli better for everyone.',
      successClose: 'Close',
      errorMessage: 'Something went wrong. Please try again.',
      adminTab: 'Feedback',
      statusNew: 'New',
      statusSeen: 'Seen',
      statusInProgress: 'In progress',
      statusResolved: 'Resolved',
      statusArchived: 'Archived',
      priorityLow: 'Low',
      priorityNormal: 'Normal',
      priorityHigh: 'High',
      priorityUrgent: 'Urgent',
      filterStatus: 'Status',
      filterCategory: 'Category',
      filterSearch: 'Search feedback...',
      filterAll: 'All',
      detailTitle: 'Feedback details',
      detailMessage: 'Message',
      detailCategory: 'Category',
      detailStatus: 'Status',
      detailPriority: 'Priority',
      detailUser: 'User',
      detailEmail: 'Email',
      detailRole: 'Role',
      detailPage: 'Page',
      detailDate: 'Date',
      detailJourney: 'User journey',
      detailInternalNotes: 'Internal notes',
      detailInternalNotesPlaceholder: 'Write internal notes here...',
      detailSave: 'Save changes',
      detailSaving: 'Saving...',
      detailSaved: 'Changes saved',
      detailBrowser: 'Browser',
      detailViewport: 'Viewport',
      detailReferrer: 'Referrer',
      detailLanguage: 'Language',
      notionSync: 'Notion sync',
      notionSynced: 'Synced',
      notionFailed: 'Sync failed',
      noSubmissions: 'No feedback yet',
      totalSubmissions: 'Total',
      anonymous: 'Anonymous',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('vennli-language');
    return saved || 'no';
  });

  useEffect(() => {
    localStorage.setItem('vennli-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'no' ? 'en' : 'no');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
